import * as React from 'react';
import userManager from '../../utils/userManager';
import logo from '../UI/Navbar/logo.png';
import { conf } from './../../constants/config/configVars';
import cover from './die_lower_res.jpg';


interface IState {
  isLoading: boolean,
  buttonText: string,
  showError: boolean
}

export class LandingPage extends React.Component<{}, IState> {

  constructor(props: any) {
    super(props);

    this.state = {
      buttonText: "Log in",
      isLoading: false,
      showError: false
    };
  }

  public onLoginClicked = () => {
    this.setState({
      buttonText: 'Try Again',
      isLoading: true,
      showError: true
    })
    userManager.signinRedirect();
    setTimeout(() => {
      this.setError()
    }, 5000);
  }

  public setError = () => {
    this.setState({
      buttonText: "Try Again",
      isLoading: false,
      showError: true,
    })
  }

  public render() {
    return (
      <section className="hero is-fullheight is-default is-bold">
        <div className="hero-head">
          <nav className="navbar">
            <div className="container">
              <div className="navbar-brand">
                <a className="navbar-item" href="#">
                  <img className="logo-image" src={logo} alt="Logo" />
                  Generator &nbsp;&nbsp; <span className="has-text-grey-lighter">{conf.build === 'dev' ? ' [ dev ]' : '  [ Beta ]'} </span>
                </a>
              </div>
              <div id="navbarMenu" className="navbar-menu">
                <div className="navbar-end">
                  <div className="tabs is-right">
                    <ul>
                      <li className="is-active"><a>Home</a></li>
                      <li><a target="_blank" href="https://github.com/open-campaign-logger/generator-library">Docs &amp; Examples</a></li>
                      <li><a target="_blank" href="https://www.campaign-community.com">Contact</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
        <div className="hero-body">
          <div className="container has-text-centered">
            <div className="columns is-vcentered">
              <div className="column is-5">
                <figure className="image is-4by3">
                  <img className="cover-image" src={cover} alt="Description" />
                </figure>
              </div>
              <div className="column is-6 is-offset-1">
                <h1 className="title is-2">
                  Generator UI
                        </h1>
                <h2 className="subtitle is-4">
                  "Generators gonna generate" - Anonymous
                        </h2>
                <br />
                <p className="has-text-centered">
                  <a className={"button is-medium is-info is-outlined " + (this.state.isLoading ? "is-loading" : '')} onClick={this.onLoginClicked}>Login</a>
                </p>
                <br />
                <small className="has-text-centered">
                  We are using cookies to log you into our Single Sign-On service <a href="https://campaign-identity.com" target="_blank">Campaign Identity</a>.<br />
                  Please ensure that 3rd-party cookies are allowed in your browser.
                </small>
              </div>
            </div>
          </div>
        </div>


        <div className="hero-foot">
          <div className="columns" style={{ textAlign: "center" }}>
            <div className="column">
              <h5><a id="ember711" href="https://campaign-logger.com/#/privacy">Our Cookie &amp; Privacy Policy</a></h5>
            </div>
            <div className="column">
              <h5><a id="ember724" href="https://campaign-logger.com/#/disclaimer">Disclaimer</a></h5>
            </div>
            <div className="column">
              <h5><a id="ember731" href="https://campaign-logger.com/#/lnotice">Legal Notice &amp; Imprint</a></h5>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Landingpage/LandingPage.tsx